module.exports = __webpack_public_path__ + "static/media/automobile-drive-svgrepo-com.a55e1fee.svg";